// FLEET COMPONENTS
export const START_FETCHING_FLEET_COMPONENTS = 'START_FETCHING_FLEET_COMPONENTS';
export const GET_FLEET_COMPONENTS_SUCCESS = 'GET_FLEET_COMPONENTS_SUCCESS';
export const GET_FLEET_COMPONENTS_ERROR = 'GET_FLEET_COMPONENTS_ERROR';

// COMPONENT TYPE FIRMWARE ANALYTICS
export const START_FETCHING_COMPONENT_TYPES = 'START_FETCHING_COMPONENT_TYPES';
export const GET_COMPONENT_TYPES_SUCCESS = 'GET_COMPONENT_TYPES_SUCCESS';
export const GET_COMPONENT_TYPES_ERROR = 'GET_COMPONENT_TYPES_ERROR';

// COMPONENT TYPE FIRMWARE APPROVAL
export const SHOW_COMPONENT_TYPE_APPROVAL_MODAL = 'SHOW_COMPONENT_TYPE_APPROVAL_MODAL';
export const HIDE_COMPONENT_TYPE_APPROVAL_MODAL = 'HIDE_COMPONENT_TYPE_APPROVAL_MODAL';
export const START_SAVING_COMPONENT_TYPE_APPROVAL = 'START_SAVING_COMPONENT_TYPE_APPROVAL';
export const SAVE_COMPONENT_TYPE_APPROVAL_SUCCESS = 'SAVE_COMPONENT_TYPE_APPROVAL_SUCCESS';
export const SAVE_COMPONENT_TYPE_APPROVAL_ERROR = 'SAVE_COMPONENT_TYPE_APPROVAL_ERROR';
export const SAVE_COMPONENT_TYPE_APPROVAL_ABORTED = 'SAVE_COMPONENT_TYPE_APPROVAL_ABORTED';
